/*import {get} from "../../../webpack/modules/ajax";

get(
    '/ajax/website/product/get-minimum-price',
    {id: document.querySelector('#product-page').dataset.productId},
    function (response) {
        let oldPriceElement = document.querySelector('#product-page .old-price span');
        let priceElement = document.querySelector('#product-page .price .price-value');
        let richCard = document.querySelector('script[type="application/ld+json"]');

        if (response.oldPrice && parseFloat(response.oldPrice) > 0 && oldPriceElement) {
            oldPriceElement.dataset.defaultOldPrice = response.oldPrice;
            oldPriceElement.innerHTML = response.oldPrice;
        }

        if (response.minPrice && priceElement) {
            priceElement.dataset.defaultPrice = response.minPrice;
            priceElement.innerHTML = response.minPrice;
        }

        if (richCard && response.minPrice && response.maxPrice) {
            let jsonld = JSON.parse(richCard.innerText);
            jsonld.offers.price = response.minPrice.toString();
            jsonld.offers.lowPrice = response.minPrice.toString();
            jsonld.offers.highPrice = response.maxPrice.toString();
            richCard.innerText = JSON.stringify(jsonld);
        }
    }
);*/

import {customDocumentEvent} from "../../../webpack/modules/events";
import {updateExclusivePremiumProduct} from "../../../webpack/modules-optimized/product-page";

customDocumentEvent('userInfoLoaded', function() {
    updateExclusivePremiumProduct(document.querySelector('#product-page'));
});